import React, {
  MouseEvent, ReactElement, useCallback, useEffect, useRef,
} from 'react';
import cx from 'classnames';
import s from './RippleEffect.module.scss';

interface RippleEffectProps {
  className?: string;
  children: ReactElement;
  duration?: number;
  center?: boolean;
}

export const RippleEffect = (props: RippleEffectProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const {
    className, children, duration, center = false,
  } = props;

  const applyContainerProperties = useCallback(() => {
    ref?.current?.classList.add(s.rippleContainer);
  }, [ref]);

  const applyStyles = useCallback((event: MouseEvent) => {
    // @ts-ignore
    const { offsetX, offsetY } = event;
    const { style } = ref.current as HTMLDivElement;
    const sizeOffset = 50;

    style.setProperty('--effect-top', `${offsetY - sizeOffset}px`);
    style.setProperty('--effect-left', `${offsetX - sizeOffset}px`);
  }, [ref]);

  const onClick = useCallback((event: MouseEvent) => {
    ref.current?.classList.remove(s.rippleActive);
    if (!center) {
      applyStyles(event);
    }

    const timer = setTimeout(() => {
      ref.current?.classList.add(s.rippleActive);
      clearTimeout(timer);
    }, duration);
  }, [applyStyles, center, duration]);

  useEffect(() => {
    applyContainerProperties();

    // @ts-ignore
    ref?.current?.addEventListener('mousedown', onClick);

    const refCurrent = ref.current;

    return () => {
      // @ts-ignore
      refCurrent?.removeEventListener('mousedown', onClick);
    };
  }, [ref, applyContainerProperties, onClick]);

  return (
    <>
      {
        React.Children.map(children, (child) => React
          .cloneElement(
              child as React.ReactElement<any>,
              {
                ref,
                className: cx(s.ripple, className),
                ...child.props,
              },
          ))
      }
    </>
  );
};
